import React from 'react';
import tw from 'twin.macro';
import styled from 'styled-components';
import { css } from 'styled-components/macro'; //eslint-disable-line
import {
  SectionHeading,
  Subheading as SubheadingBase,
} from 'components/misc/Headings.js';
import { PrimaryButton as PrimaryButtonBase } from 'components/misc/Buttons.js';
import { OutlineButton as OutlineButtonBase } from 'components/misc/Buttons.js';

import TeamIllustrationSrc from 'images/team-illustration-2.svg';
import { ReactComponent as SvgDotPattern } from 'images/dot-pattern.svg';

// import ImgComp from 'components/misc/ImgComp.js';
// import girlOrig from 'images/app/md_model_023.jpg';
// import girlTrans from 'images/app/md_model_023_rst.jpg';

const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between  max-w-[1200px] mx-auto py-10 md:py-16 items-center`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`md:w-6/12 shrink-0 relative`;
const TextColumn = styled(Column)((props) => [
  tw`md:w-6/12 mt-6 md:mt-0`,
  props.textOnLeft
    ? tw`md:mr-12 lg:mr-16 md:order-first`
    : tw`md:ml-12 lg:ml-16 md:order-last`,
]);

const Image = styled.img((props) => [
  tw`object-cover`,
  props.imageRounded && tw`rounded`,
  props.imageBorder && tw`border`,
  props.imageShadow && tw`shadow`,
]);
const Video = tw.video`rounded-4xl max-h-[300px] lg:max-h-[400px] mx-auto`;

const DecoratorBlob = styled(SvgDotPattern)((props) => [
  tw`w-20 h-20 absolute right-0 bottom-0 transform translate-x-1/2 translate-y-1/2 fill-current text-primary-500 -z-10`,
]);

const TextContent = tw.div`lg:py-8 text-center md:text-left`;

const Subheading = tw(SubheadingBase)`text-center md:text-left`;
const Heading = tw(
  SectionHeading
)`mt-4 font-black text-left text-2xl sm:text-3xl lg:text-4xl text-center md:text-left leading-tight`;
const Description = tw.p`mt-4 text-center md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100`;

const buttonStyleCss = tw`mt-8 md:mt-8 text-sm inline-block mx-auto md:mx-0 py-4`;

const PrimaryButton = styled(PrimaryButtonBase)((props) => [
  buttonStyleCss,
  tw`bg-gray-900 hocus:bg-gray-700`,
  props.buttonRounded && tw`rounded-full`,
  props.buttonCss && props.buttonCss,
]);

const OutlineButton = styled(OutlineButtonBase)((props) => [
  buttonStyleCss,
  props.buttonRounded && tw`rounded-full`,
  props.buttonCss && props.buttonCss,
]);

export default ({
  subheading = '',
  heading = (
    <>
      Designed & Developed by <span tw="text-primary-500">Professionals.</span>
    </>
  ),
  description = '',
  isOutlineButton = false,
  primaryButtonText = 'Learn More',
  primaryButtonUrl = '/moresample',
  primaryButtonCss = null,
  videoSrc = null,
  imageSrc = null,
  imageAlt = '',
  buttonRounded = true,
  imageRounded = true,
  imageBorder = false,
  imageShadow = false,
  imageCss = null,
  imageDecoratorBlob = false,
  imageDecoratorBlobCss = null,
  textOnLeft = true,
}) => {
  // The textOnLeft boolean prop can be used to display either the text on left or right side of the image.

  return (
    <Container>
      <TwoColumn>
        <ImageColumn>
          {/* <ImgComp
            style={{
              maxHeight: '400px',
              maxWidth: '500px',
              borderRadius: '2.5rem',
            }}
            itemOneSrc={girlOrig}
            itemTwoSrc={girlTrans}
          /> */}
          {imageSrc && (
            <div
              css={[
                tw`rounded-4xl`,
                tw`max-w-[500px]`,
                tw`overflow-hidden`,
                textOnLeft
                  ? tw`mx-auto md:ml-auto md:mr-0`
                  : tw`mx-auto md:mr-auto md:ml-0`,
              ]}
            >
              <Image
                css={imageCss}
                src={imageSrc}
                imageBorder={imageBorder}
                imageShadow={imageShadow}
                imageRounded={imageRounded}
                alt={imageAlt}
              />
            </div>
          )}
          {videoSrc && (
            <div
              css={[
                tw`rounded-4xl`,
                tw`max-w-[500px]`,
                tw`overflow-hidden`,
                textOnLeft
                  ? tw`mx-auto md:ml-auto md:mr-0 md:mt-0`
                  : tw`mx-auto md:mr-auto md:ml-0`,
              ]}
            >
              <video preload="auto" autoPlay loop muted playsInline={true}>
                <source src={videoSrc} type="video/mp4" />
              </video>
            </div>
          )}
          {imageDecoratorBlob && <DecoratorBlob css={imageDecoratorBlobCss} />}
        </ImageColumn>
        <TextColumn textOnLeft={textOnLeft}>
          <TextContent>
            {/* <Subheading>{subheading}</Subheading> */}
            <Heading>{heading}</Heading>
            <Description>{description}</Description>
            <StyledButton
              isOutline={isOutlineButton}
              buttonRounded={buttonRounded}
              as="a"
              url={primaryButtonUrl}
              text={primaryButtonText}
              buttonCss={primaryButtonCss}
              target="_blank"
            />
          </TextContent>
        </TextColumn>
      </TwoColumn>
    </Container>
  );
};

const StyledButton = ({ text, url, isOutline = false, ...props }) => {
  return isOutline ? (
    <OutlineButton href={url} {...props}>
      {text}
    </OutlineButton>
  ) : (
    <PrimaryButton href={url} {...props}>
      {text}
    </PrimaryButton>
  );
};
